import React from "react";
import { NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Menu, Cancel, Cart, PinAlt, Package, Coin, WarningTriangleOutline, CollageFrame, Wifi, Tv, Phone, Building } from "iconoir-react";
import "./Navbar.css";
import { LogIn } from "iconoir-react";
import Logonew from "../../assets/LogoNew.webp"
import { trackNavClick } from "../../../utils/gtm";

export default function Navbar() {
  const location = useLocation();

  return (
    <div className="header">
      <div className="logo">
        <a href="/">
          <img className="w-32" src={Logonew} alt="" />
        </a>
      </div>
      <input type="checkbox" id="chk" />
      <label htmlFor="chk" className="show-menu-btn">
        <Menu color="#303030" height={26} width={26} strokeWidth={2} />
      </label>

      <ul className="menu">
        <div className="options1" >
          {/* <a href="/" style={{gap: "3px"}}><Home style={{width: '20px'}}/>Inicio</a> */}
          <a href="/Empresarial" style={{ gap: "5px" }} onClick={() => trackNavClick("Empresarial")}><Building style={{ width: '20px' }} />Empresarial</a>
          <a href="/Empaquetarout" style={{ gap: "5px" }} onClick={() => trackNavClick("Agregar servicios")}><Package style={{ width: '20px' }} />Agregar servicios</a>
          <a href="/valoin" style={{ gap: "5px" }} onClick={() => trackNavClick("Cobertura")}><PinAlt style={{ width: '20px' }} /> Cobertura</a>
          <a href="/planes" style={{ gap: "5px" }} onClick={() => trackNavClick("Comprar")}><Cart style={{ width: '20px' }} />Comprar</a>
          <a href="https://pagos.emcali.com.co/pagosweb/checkout" style={{ gap: "5px" }} onClick={() => trackNavClick("Pagos")}><Coin style={{ width: '20px' }} />Pagos</a>
          <a href="https://www.emcali.com.co/atencion-y-servicio-a-la-ciudadania/pqrs" style={{ gap: "5px" }} onClick={() => trackNavClick("PQR")}><WarningTriangleOutline style={{ width: '20px' }} />PQR</a>
          <div style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
            <CollageFrame style={{ width: '20px' }} />
            <NavDropdown title="Servicios" id="navbarScrollingDropdown">
              <NavDropdown.Item as={Link} to="/Intpersonas" style={{ gap: '10px' }} onClick={() => trackNavClick("Servicios - Internet")}>
                <Wifi style={{ width: '20px' }} />Internet
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/tvpersonas" style={{ gap: '10px' }} onClick={() => trackNavClick("Servicios - Televisión")}>
                <Tv style={{ width: '20px' }} />Televisión
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Telefoniapersonas" style={{ gap: '10px' }} onClick={() => trackNavClick("Servicios - Telefonía")}>
                <Phone style={{ width: '20px' }} /> Telefonía
              </NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/Awspersonas">
              AWS
            </NavDropdown.Item> */}
            </NavDropdown>
          </div>
          </div>
          <div style={{display: "flex", gap: "1px", justifyContent: "center"}}>
            <a href="/Login" className="boton">
              <Link to="/Login" state={{ from: location.pathname }}>
                <button className="bg-[#020617] text-white border-[#020617] shadow-md flex justify-center gap-1 items-center h-10 hover:bg-colorprimary hover:text-white rounded-md ..." onClick={() => trackNavClick("Ingresar")}>
                  <LogIn
                    style={{ width: "fit-content", height: "fit-content" }}
                  />
                  <b>Ingresar</b>
                </button>
              </Link>
            </a>
          </div>
        
        <label htmlFor="chk" className="hide-menu-btn">
          <Cancel color="#303030" height={26} width={26} strokeWidth={2} />
        </label>
      </ul>
    </div>
  );
}
